require('../css/main.css');

require('./gallery.js');
require('./filter.js');
require('./menu.js');